import { FC } from 'react';
import { Card, Table, Tag, Empty, Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { EmergencyContactAdmin } from '../../../../../models/admin/student-admin.model';

const { Text } = Typography;

interface EmergencyContactsTabProps {
  contacts: EmergencyContactAdmin[];
}

const EmergencyContactsTab: FC<EmergencyContactsTabProps> = ({ contacts }) => {
  const columns = [
    {
      title: 'Name',
      key: 'name',
      render: (_: any, record: EmergencyContactAdmin) =>
        `${record.firstName} ${record.lastName}`,
    },
    {
      title: 'Relation',
      dataIndex: 'relation',
      key: 'relation',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      render: (phone: string, record: EmergencyContactAdmin) => (
        <div>
          <div>{phone || '-'}</div>
          {record.altPhone && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              Alt: {record.altPhone}
            </Text>
          )}
        </div>
      ),
    },
    {
      title: 'Can Pickup',
      dataIndex: 'canPickup',
      key: 'canPickup',
      align: 'center' as const,
      render: (canPickup: boolean) =>
        canPickup ? (
          <Tag icon={<CheckCircleOutlined />} color="success">
            Yes
          </Tag>
        ) : (
          <Tag icon={<CloseCircleOutlined />} color="default">
            No
          </Tag>
        ),
    },
    {
      title: 'Authorized',
      dataIndex: 'authorized',
      key: 'authorized',
      align: 'center' as const,
      render: (authorized: boolean) =>
        authorized ? (
          <Tag icon={<CheckCircleOutlined />} color="success">
            Yes
          </Tag>
        ) : (
          <Tag icon={<CloseCircleOutlined />} color="default">
            No
          </Tag>
        ),
    },
  ];

  return (
    <Card title="Emergency Contacts">
      {contacts.length > 0 ? (
        <Table
          dataSource={contacts}
          columns={columns}
          rowKey="id"
          pagination={false}
          size="middle"
        />
      ) : (
        <Empty description="No emergency contacts" />
      )}
    </Card>
  );
};

export default EmergencyContactsTab;
